import React__default from 'react';
import { I as InlineTouchLinkButton, a as InlineTouchLinkAnchor } from '../TouchLink.styles-B5B1gO5F.js';
import { T as TouchLinkBody } from '../TouchLinkBody-BIV4FyYx.js';

const InlineTouchLink = ({
  children,
  href,
  onClick
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(InlineTouchLinkButton, {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
  }
  return /*#__PURE__*/React__default.createElement(InlineTouchLinkAnchor, {
    href: href
  }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
};

export { InlineTouchLink as I };
//# sourceMappingURL=InlineTouchLink-J5O_eC-9.js.map
